import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import shortid from "shortid";
import { fromJS } from "immutable";
import { withTranslation } from "react-i18next";

import { getItem, setItem, removeItem } from "../../common/StorageUtils";
import {
  getCookie,
  checkedCurrencySymbol,
  setCookie,
  settingCost,
  getPerItemCouponCost,
  returnComma,
  getAddonPrice,
  getAddonTitle,
} from "../../common/Utils";
import _Fetch from "../../common/Fetches";
import { YEN_INCOM_TAX_PER } from "../../common/Constants";
import SERVER_URL from '../../common/Settings';

import Modal2 from "../../containers/baseModal/BaseModal";
import ConfirmModal from "../../containers/baseModal/ConfirmModal";

import Step from "../../components/step/Step";
import Item from "../../components/item/MyCartItem";
import DivButton from "../../components/button/DivButton";
import Input from "../../components/input/Input";
import ConfirmCartModal from "../../components/modal/ConfirmCartModal";
import AddOnOptionModal from "../../components/modal/AddOnOptionModal";
import AddonConfirmModal from "../../components/modal/AddonConfirmModal";

import ShippingInfo from "./ShippingInfo";
import PaymentInfo from "./PaymentInfo";

import Modal from "../../lib/modal";

import Notice from "./Notice";
import NoticePolicy from "./NoticePolicy";

import { Consumer } from "../../Context";
import CheckInput from "../../components/input/CheckInput";

Modal.defaultStyles.overlay.backgroundColor = "rgba(0, 0, 0, 0.3)";

const STEP_MENU = ["Shop", "My Cart"];
const info = "/svg/info.svg";
const arrowWhite = "/svg/arrow_wr.svg";
const close = "/svg/close.svg";
const couponCheck = "/svg/couponCheck.svg";

const RedicrectionUrl = () => {
  const env = process.env.NODE_ENV;

  console.log("-----------------", env);

  const isDev = env === "development";
  // const isSatge = env === 'stage';
  // const isProd = env = 'production';

  if (isDev) return "http://localhost:3001/orderReview";

  // if (isSatge) return 'https://glocli.gloveworks.net/orderReview';

  let rediUrl = document.location.origin
    ? document.location.origin
    : "https://www.gloveworks.net";
  rediUrl += "/orderReview";
  return rediUrl;

  // return 'https://www.gloveworks.net/orderReview';
  // return 'https://client.gloveworks.net/orderReview';
};

/** @description 초기 subtotal 값 계산 initData() 에서 호출
 * @param {Array} data 카트 아이템 정보
 * @return {Number} 서브토탈
 */
function initCalSubtotal(data, i18n) {
  let subtotal = 0;
  data.map(
    (item) => (subtotal += settingCost(i18n.language, item) * item.quantity)
  );
  return Math.abs(subtotal);
}

function calculateAddonCost(addonData, language) {
  const products = addonData && Array.isArray(addonData.addons) ? addonData.addons : [];
  const addonIds = addonData && Array.isArray(addonData.addon_ids) ? addonData.addon_ids : [];
  if (products.length > 0 && (addonIds.length === 0 || products.length === addonIds.length)) {
    return products.reduce((sum, product) => sum + getAddonPrice(product, language), 0);
  }
  return Number((addonData && addonData.addon_cost) || 0);
}

function recalculateAddonDataMap(addonDataMap, language) {
  return Object.keys(addonDataMap).reduce((result, key) => {
    result[key] = {
      ...addonDataMap[key],
      addon_cost: calculateAddonCost(addonDataMap[key], language),
    };
    return result;
  }, {});
}

function calculateTotalAddonCost(addonDataMap, language) {
  return Object.values(addonDataMap).reduce(
    (sum, addon) => sum + calculateAddonCost(addon, language),
    0
  );
}

function settingCountryCode(lanCode) {
  switch (lanCode) {
    case "ko":
      return 3;
    case "ja":
      return 2;
    default:
      return 1;
  }
}

function setCouponInputBorderColor(data) {
  if (data === null) return "#dadada";
  if (data === undefined) return "#e85454";
  return "#40c380";
}

function sumQty(data) {
  let qty = 0;
  data.map((item) => (qty += item.quantity));
  return qty;
}

class Cart extends Component {
  constructor(props) {
    super(props);
    /** @description state 설명
     * @property {Array} data 수량정보를 제외한 아이템 정보들 (나중에 pid_pd를 카트 id로 변경 필요)
     * @property {Number} step SPA 형식으로 0일땐 카트 0이상일시 체크아웃 단계별
     * @property {Number} subtotal this.ssubtotal 사전 처리후 담을 변수
     *
     * @description 멤버 변수 설명 this 생략
     * @property {Number} subtotal state subtotal 넣기 전 사전 처리를 위한 아이템 총 가격 변수
     * @property {Array} data state data에 넣기전 사전처리 값을 담을 변수
     * @property {Object} userData 로그인시 쿠키값에서 유저 정보를 지닌 변수
     */
    this.state = {
      data: null,
      subtotal: 0,
      step: 0,
      isViewDetailModal: false,
      coupon: null,
      totalCouponCost: 0,
      isModal: false,
      isPolicyModal: false,
      isModal2: false,
      bodyText2: "",
      isPrepaidModal: false,
      // 추가옵션 관련 상태
      addonDataMap: {}, // { pid_cart: addonData }
      isAddonModal: false,
      selectedCartItem: null,
      isAddonConfirmModal: false,
      highlightAddonButtons: false,
      totalAddonCost: 0,
    };

    // subtotal 계산을 위한 변수
    this.subtotal = 0;

    // 카트아이템과 수량 정보를 지닌 데이트 immutable 데이터로 정의 한다.
    this.data = [];

    // 유저 데이터 담을 변수
    this.userData = null;

    // 커스텀 아이템 뷰 디테일 아이템을 담을 변수
    this.viewDetailData = null;

    // 쇼핑 어드레스를 담을 변수
    this.shippingAddr = null;

    // 빌링 어드레스를 담을 변수
    this.billingAddr = null;

    // 배송비 담을 부분
    this.deliCost = null;

    this.orderId = [];

    this.IMP = window.IMP;

    this.couponInput = null;
    this.checkArr = [false, false];
    this.shippingNode = null;

    this.onNext = this.closeModal;
    this.onPrepaidNext = this.closePrepaidModal;

    this.prepaidModalLeftBtn = () => {
      this.props.history.push("/orderHistory");
    };
  }

  componentDidMount() {
    document.body.style.backgroundColor = "#fafafa";
    window.document.body.addEventListener("keyup", this.onkeyup);

    try {
      window.gtag("event", "conversion", {
        send_to: "AW-10904637938/HULmCMbF8b4DEPKj3s8o",
        transaction_id: "",
      });
    } catch (e) {
      console.log("gtag error");
    }

    this.initData();
  }

  componentWillUnmount() {
    window.document.body.removeEventListener("keyup", this.onkeyup);
  }

  // 싱글 페이지라 헤더에서 다시 Shop 아이콘 클릭시 초기 화념으로 전환을 위해 선언
  componentWillReceiveProps(nextProps) {
    if (this.couponInput) {
      this.couponInput.value = "";
    }
    const addonDataMap = recalculateAddonDataMap(
      this.state.addonDataMap,
      nextProps.i18n.language
    );
    this.setState(
      {
        step: 0,
        coupon: null,
        totalCouponCost: 0,
        addonDataMap,
        totalAddonCost: calculateTotalAddonCost(addonDataMap, nextProps.i18n.language),
      },
      () => this.initData(nextProps.i18n.language)
    );
  }

  onkeyup = (e) => {
    const { step } = this.state;
    if (e.keyCode === 13 && step === 0) return this.onCoupon();

    return null;
  };

  openModal = (bodyText2) => {
    this.setState({
      isModal2: true,
      bodyText2,
    });
  };

  closeModal = () => {
    this.setState({
      isModal2: false,
      bodyText2: "",
    });
  };

  openPrepaidModal = (bodyPrepaidText) => {
    this.setState({
      isPrepaidModal: true,
      bodyPrepaidText,
    });
  };

  closePrepaidModal = () => {
    this.setState({
      isPrepaidModal: false,
      bodyPrepaidText: "",
    });
  };

  // 추가옵션 모달 열기
  openAddonModal = (cartItem) => {
    this.setState({
      isAddonModal: true,
      selectedCartItem: cartItem,
    });
  };

  // 추가옵션 모달 닫기
  closeAddonModal = () => {
    this.setState({
      isAddonModal: false,
      selectedCartItem: null,
    });
  };

  // 추가옵션 확인 모달 열기
  openAddonConfirmModal = () => {
    this.setState({
      isAddonConfirmModal: true,
      highlightAddonButtons: true,
    });
  };

  // 추가옵션 확인 모달 닫기
  closeAddonConfirmModal = () => {
    this.setState({
      isAddonConfirmModal: false,
      highlightAddonButtons: false,
    });
  };

  // 추가옵션 저장 핸들러
  handleAddonConfirm = async (addonData) => {
    const { selectedCartItem, addonDataMap } = this.state;
    if (!selectedCartItem) return;

    const cartKey = selectedCartItem.pid_cart || selectedCartItem.pid_item;

    // cart_addon API 호출 (로그인 상태일 때만)
    if (this.userData && selectedCartItem.pid_cart) {
      try {
        const existingAddon = addonDataMap[cartKey];
        if (existingAddon && existingAddon.pid_cart_addon) {
          // 업데이트
          const api = {
            url: `${SERVER_URL}/gloveworks/restapi/cart_addon/update_cart_addon`,
            method: 'PUT',
          };
          await _Fetch(api, '', {
            cart_addon: {
              pid_cart_addon: existingAddon.pid_cart_addon,
              addon_ids: JSON.stringify(addonData.addon_ids),
              addon_request: addonData.addon_request,
              addon_ref_img: addonData.addon_ref_imgs.map(img => img.url).join(','),
              addon_cost: addonData.addon_cost,
            },
          });
        } else {
          // 새로 생성
          const api = {
            url: `${SERVER_URL}/gloveworks/restapi/cart_addon/insert_cart_addon`,
            method: 'POST',
          };
          const res = await _Fetch(api, '', {
            cart_addon: {
              pid_cart: selectedCartItem.pid_cart,
              addon_ids: JSON.stringify(addonData.addon_ids),
              addon_request: addonData.addon_request,
              addon_ref_img: addonData.addon_ref_imgs.map(img => img.url).join(','),
              addon_cost: addonData.addon_cost,
            },
          });
          addonData.pid_cart_addon = res;
        }
      } catch (e) {
        console.log('Failed to save cart addon:', e);
      }
    }

    // 로컬 상태 업데이트
    const newAddonDataMap = {
      ...addonDataMap,
      [cartKey]: addonData,
    };

    // 게스트는 세션 스토리지에 영속 (새로고침 유실 방지)
    if (!this.userData) setItem("cart_addons", newAddonDataMap);

    // 총 추가옵션 비용 계산
    const totalAddonCost = calculateTotalAddonCost(newAddonDataMap, this.props.i18n.language);

    this.setState({
      addonDataMap: newAddonDataMap,
      totalAddonCost,
      isAddonModal: false,
      selectedCartItem: null,
    });
  };

  // 추가옵션 삭제
  handleAddonDelete = async (cartKey) => {
    const { addonDataMap } = this.state;
    const addonData = addonDataMap[cartKey];

    if (this.userData && addonData && addonData.pid_cart_addon) {
      try {
        const api = {
          url: `${SERVER_URL}/gloveworks/restapi/cart_addon/delete_cart_addon`,
          method: 'DELETE',
        };
        await _Fetch(api, '', {
          cart_addon: {
            pid_cart_addon: addonData.pid_cart_addon,
          },
        });
      } catch (e) {
        console.log('Failed to delete cart addon:', e);
      }
    }

    const newAddonDataMap = { ...addonDataMap };
    delete newAddonDataMap[cartKey];

    if (!this.userData) setItem("cart_addons", newAddonDataMap);

    const totalAddonCost = calculateTotalAddonCost(newAddonDataMap, this.props.i18n.language);

    this.setState({
      addonDataMap: newAddonDataMap,
      totalAddonCost,
    });
  };

  // 커스터마이즈 상품 중 추가옵션이 없는 아이템 체크
  hasCustomItemWithoutAddon = () => {
    const { data, addonDataMap } = this.state;
    if (!data) return false;

    const customItems = data.filter(item => item.b_custom === 1);
    return customItems.some(item => {
      const cartKey = item.pid_cart || item.pid_item;
      return !addonDataMap[cartKey];
    });
  };

  // 커스터마이즈 아이템 목록 가져오기
  getCustomItemsWithAddonStatus = () => {
    const { data, addonDataMap } = this.state;
    if (!data) return [];

    return data
      .filter(item => item.b_custom === 1)
      .map(item => {
        const cartKey = item.pid_cart || item.pid_item;
        return {
          ...item,
          addonData: addonDataMap[cartKey] || null,
        };
      });
  };

  // 잔존 sessionStorage cart 자동 재머지 (직전 머지 부분 실패 / 1164 로그아웃 후 재로그인).
  // 이미지는 이미 S3 업로드 완료. DB cart_insert 만 재시도.
  async _retryMergeSessionCart() {
    if (!this.userData) return;
    const cartData = getItem("cart");
    if (!cartData || !Array.isArray(cartData) || cartData.length === 0) return;

    const remaining = [];
    for (let i = 0; i < cartData.length; i += 1) {
      const item = cartData[i];
      try {
        const api = getItem("restAPI").model_desc.cart_insert;
        const body = {
          cart: { pid_user: this.userData.user.pid_user, ...item },
        };
        await _Fetch(api, "", body);
      } catch (e) {
        console.error("retry cart merge failed", e);
        remaining.push(item);
      }
    }

    if (remaining.length === 0) {
      removeItem("cart");
      this.openModal("Your previous cart items were restored.");
    } else {
      setItem("cart", remaining);
      this.openModal(
        `Could not restore ${remaining.length} cart item(s) from previous session. Please try designing again.`
      );
    }
  }

  async initData(language = this.props.i18n.language) {
    this.userData =
      getCookie("userData") === "" ? null : JSON.parse(getCookie("userData"));
    console.log(this.userData);
    let data = [];
    let addonDataMap = {};
    let totalAddonCost = 0;

    // 로그인 햇을 경우 카트는 DB에서 가져온다.
    if (this.userData) {
      // DB 조회 전에 잔존 sessionStorage cart 자동 머지 재시도.
      await this._retryMergeSessionCart();

      try {
        const api = getItem("restAPI").model_desc.cart_get_my;
        const res = await _Fetch(
          api,
          `?pid_user=${this.userData.user.pid_user}`,
          []
        );
        // console.log(res);
        data = res;

        // addon_product 전체 목록 먼저 조회
        let allAddonProducts = [];
        try {
          const addonProductApi = {
            url: `${SERVER_URL}/gloveworks/restapi/addon_product/get`,
            method: 'GET',
          };
          allAddonProducts = await _Fetch(addonProductApi, '', []);
        } catch (e) {
          console.log('Failed to fetch addon products:', e);
        }

        // cart_addon 데이터 조회
        for (const item of data) {
          if (item.pid_cart && Number(item.b_custom) === 1) {
            try {
              const addonApi = {
                url: `${SERVER_URL}/gloveworks/restapi/cart_addon/get_by_cart`,
                method: 'GET',
              };
              const addonRes = await _Fetch(addonApi, `?pid_cart=${item.pid_cart}`, []);
              if (addonRes && addonRes.length > 0) {
                const addon = addonRes[0];
                const savedIds = JSON.parse(addon.addon_ids || '[]');
                // addon_ids로 실제 addon 정보 매칭
                const masterLoaded = Array.isArray(allAddonProducts) && allAddonProducts.length > 0;
                const addons = savedIds
                  .map(id => allAddonProducts.find(p => Number(p.pid_addon) === Number(id)))
                  .filter(Boolean);
                // 마스터에서 삭제된 옵션은 카트에서 이름/금액 모두 제외 (존재하지 않는 옵션 과금 방지).
                // 마스터 조회 실패 시엔 저장값 유지 (calculateAddonCost가 저장 합계로 fallback)
                const addonIds = masterLoaded ? addons.map(a => a.pid_addon) : savedIds;
                const currentAddonCost = calculateAddonCost({
                  addon_ids: addonIds,
                  addons,
                  addon_cost: addon.addon_cost,
                }, language);

                addonDataMap[item.pid_cart] = {
                  pid_cart_addon: addon.pid_cart_addon,
                  addon_ids: addonIds,
                  addons: addons,
                  addon_request: addon.addon_request || '',
                  addon_ref_imgs: addon.addon_ref_img ? addon.addon_ref_img.split(',').map(url => ({ url })) : [],
                  addon_cost: currentAddonCost,
                };
              }
            } catch (e) {
              console.log('Failed to fetch cart addon:', e);
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      // 비로그인시 카트 데이터는 세션 스토리지에서 가져온다.
      // 세션 스토리지에 아이템 정보 유무 판단 후 데이터가 있다면 세션스토리지 cart부분에서 데이터 가져옴 없다면 빈배열
      data = getItem("cart") === null ? [] : getItem("cart");

      // 게스트 애드온 복원 (새로고침 시 유실 방지). 현재 카트에 없는 키는 버림.
      // 로그인 경로와 동일하게 마스터 가격을 재조회해 세션의 옛 가격으로 청구되지 않게 함
      const savedAddons = getItem("cart_addons") || {};
      const savedKeys = data
        .map((item) => item.pid_cart || item.pid_item)
        .filter((key) => key && savedAddons[key]);
      if (savedKeys.length > 0) {
        let allAddonProducts = [];
        try {
          const addonProductApi = {
            url: `${SERVER_URL}/gloveworks/restapi/addon_product/get`,
            method: 'GET',
          };
          allAddonProducts = await _Fetch(addonProductApi, '', []);
        } catch (e) {
          console.log('Failed to fetch addon products:', e);
        }
        savedKeys.forEach((key) => {
          const saved = savedAddons[key];
          const savedIds = Array.isArray(saved.addon_ids) ? saved.addon_ids : [];
          const masterLoaded = Array.isArray(allAddonProducts) && allAddonProducts.length > 0;
          const addons = masterLoaded
            ? savedIds
              .map((id) => allAddonProducts.find((p) => Number(p.pid_addon) === Number(id)))
              .filter(Boolean)
            : (saved.addons || []);
          // 마스터에서 삭제된 옵션은 제외하고 금액 재계산 (로그인 경로와 동일 규칙)
          const ids = masterLoaded ? addons.map((a) => a.pid_addon) : savedIds;
          addonDataMap[key] = {
            ...saved,
            addon_ids: ids,
            addons,
            addon_cost: calculateAddonCost(
              { addon_ids: ids, addons, addon_cost: saved.addon_cost },
              language
            ),
          };
        });
      }
    }

    // 세션스토리지에서 가져온 데이터에 수량 정보 추가 임뮤터블 데이터 형식으로 저장
    // immutable 참고 페이지 주소: http://untangled.io/the-missing-immutable-js-manual/
    this.data = fromJS(data);
    console.log(this.data.toJS());

    // subtotal 계산
    this.subtotal = initCalSubtotal(this.data.toJS(), { language });
    totalAddonCost = calculateTotalAddonCost(addonDataMap, language);

    // 스테이트에는 임뮤터블 데이터가 저장 되지 않게 한다. 배열 타입으로 들어가야됌
    this.setState({
      data: this.data.toJS(),
      subtotal: this.subtotal,
      addonDataMap,
      totalAddonCost,
    });
  }

  async onDelete(item, idx) {
    const { actions } = this.props;
    // 삭제할 데이터 immutable 삭제 후 재 할당
    this.data = this.data.delete(idx);

    // subtotal 계산
    this.subtotal =
      Number(this.subtotal) -
      settingCost(this.props.i18n.language, item) * item.quantity;

    // S3 이미지 원본은 삭제하지 않는다. 재주문/기주문(od_pd)이 같은 객체를 참조하므로
    // 카트에서 지우면 주문 프리뷰가 깨짐 (2607 피드백 5번). 고아 객체는 저장비용만 감수
    if (this.userData) {
      try {
        const api = getItem("restAPI").model_desc.cart_delete;
        const body = {
          cart: {
            pid_cart: item.pid_cart,
            pid_user: this.userData.user.pid_user,
          },
        };
        await _Fetch(api, "", body);
      } catch (e) {
        console.log(e);
        if (e.status === 1164) {
          this.openModal(
            "Your login information is invalid. Please login again."
          );
          setCookie("userData", "", -1);
          this.props.history.push("/login");
        }
      }
    } else {
      // 세션 스토리지에 데이터 수정
      setItem("cart", this.data.toJS());
    }

    if (this.couponInput) {
      this.couponInput.value = "";
    }

    // 삭제된 글러브의 추가옵션도 함께 제거(잔여 옵션료 청구 방지). handleAddonDelete와 동일 패턴
    const addonCartKey = item.pid_cart || item.pid_item;
    const newAddonDataMap = { ...this.state.addonDataMap };
    delete newAddonDataMap[addonCartKey];
    if (!this.userData) setItem("cart_addons", newAddonDataMap);
    const totalAddonCost = calculateTotalAddonCost(newAddonDataMap, this.props.i18n.language);

    return this.setState(
      {
        data: this.data.toJS(),
        subtotal: this.subtotal,
        coupon: null,
        totalCouponCost: 0,
        addonDataMap: newAddonDataMap,
        totalAddonCost,
      },
      () => {
        const { data } = this.state;
        actions.setCount(data.length);
      }
    );
  }

  /** @description 수량 업데이트 버튼을 클릭 했을 때 호출
   * @param {Object} item 카트 정보
   * @param {String} inputQty 인풋 입력된 숫자를 지
   * @param {Number} idx 아이템 인덱스
   */
  async onCalculation(item, inputQty, idx) {
    // 수량 값 셋팅
    this.data = this.data.setIn([idx, "quantity"], Number(inputQty));
    console.log(this.data.toJS()[idx].quantity);

    // 변화된 수량
    const afterQty = this.data.toJS()[idx].quantity;
    // total cost 계산
    if (afterQty !== 0) {
      if (item.quantity > afterQty) {
        this.subtotal =
          Number(this.subtotal) -
          settingCost(this.props.i18n.language, item) *
            (item.quantity - afterQty);
      } else {
        this.subtotal =
          Number(this.subtotal) +
          settingCost(this.props.i18n.language, item) *
            (afterQty - item.quantity);
      }
    }

    if (this.userData) {
      console.log(Number(inputQty), item.pid_cart);
      try {
        const api = getItem("restAPI").model_desc.cart_update;
        const body = {
          cart: {
            pid_cart: item.pid_cart,
            quantity: Number(inputQty),
            pid_user: this.userData.user.pid_user,
          },
        };
        console.log(body);
        await _Fetch(api, "", body);
      } catch (e) {
        console.log(e);
        if (e.status === 1164) {
          this.openModal(
            "Your login information is invalid. Please login again."
          );
          setCookie("userData", "", -1);
          this.props.history.push("/login");
        }
      }
    } else {
      setItem("cart", this.data.toJS());
    }

    if (this.couponInput) {
      this.couponInput.value = "";
    }

    return this.setState({
      data: this.data.toJS(),
      subtotal: this.subtotal,
      coupon: null,
      totalCouponCost: 0,
    });
  }

  iamportModule(paymentRes) {
    this.IMP.request_pay(paymentRes.imp_params, (rsp) => {
      if (rsp.success) {
        // 결제 성공 알림 후 orderReview 이동 (redirect만 있어 결제 여부 혼동된다는 문의 대응).
        try {
          window.alert(
            `Payment completed successfully.\nWe are taking you to the order summary.`
          );
        } catch (e) {
          console.log("payment alert error", e);
        }
        this.props.history.push("/orderReview");
      } else {
        const msg = rsp.error_msg || "Payment failed. Please try again.";
        this.openModal(msg);
      }
      // let msg = '결제가 완료되었습니다.';
      // msg += `고유ID : ${rsp.imp_uid}`;
      // msg += `상점 거래ID : ${rsp.merchant_uid}`;
      // msg += `결제 금액 : ${rsp.paid_amount}`;
      // msg += `카드 승인번호 : ${rsp.apply_num}`;
      //       this.openModal(msg);
      // if (rsp.success) {
      //   window.$.ajax({
      //     url: '/payments/complete',
      //     type: 'POST',
      //     dataType: 'json',
      //     data: {
      //       imp_uid: rsp.imp_uid,
      //     },
      //   }).done((data) => {
      //     let msg = '결제가 완료되었습니다.';
      //     msg += `고유ID : ${rsp.imp_uid}`;
      //     msg += `상점 거래ID : ${rsp.merchant_uid}`;
      //     msg += `결제 금액 : ${rsp.paid_amount}`;
      //     msg += `카드 승인번호 : ${rsp.apply_num}`;
      //     this.openModal(msg);
      //   });
      // } else {
      //   const msg = rsp.error_msg;
      //   this.openModal(msg);
      // }
    });
  }

  // 게좌 이체시 리덕스 카운트 처리
  onManageStateAccChkOut = (firstName) => {
    console.log("name", firstName);
    if (!firstName) return this.openModal("Please entered name");

    const { coupon } = this.state;

    console.log("acc coupon", coupon);

    return this.onAccountCheckOut(firstName, coupon);
  };

  // 계좌이체시
  async onAccountCheckOut(firstName, coupon) {
    try {
      const odAddr = this.shippingAddr;
      delete odAddr.date_creation;
      delete odAddr.pid_addr;
      delete odAddr.b_base;
      delete odAddr.pid_user;

      const paymentApi = getItem("restAPI").model_desc.shop_user_init_payment;

      const qty = sumQty(this.state.data);
      const isDiscountShppingFee = qty > 3;

      const shippingTotal =
        this.deliCost.customTotalFee + this.deliCost.stockTotalFee;

      const beforeDiscountShppingFee = isDiscountShppingFee
        ? shippingTotal * 0.2
        : 0;

      const discountShppingFee =
        this.props.i18n.language === "en"
          ? beforeDiscountShppingFee.toFixed(2)
          : Math.ceil(beforeDiscountShppingFee);

      const couponFee =
        this.props.i18n.language === "en"
          ? this.calCouponCost(coupon, this.state.data).toFixed(2)
          : Math.ceil(this.calCouponCost(coupon, this.state.data));

      //  OUTLIER - 20240122 - 2번
      // const tax =
      //   this.props.i18n.language === "ja"
      //     ? Math.floor(Number((this.subtotal - couponFee) * YEN_INCOM_TAX_PER))
      //     : 0;
      const tax = 0;

      console.log(
        "subtotal",
        this.subtotal,
        "custom total",
        this.deliCost.customTotalFee,
        "stock total",
        this.deliCost.stockTotalFee,
        "coupon total",
        this.state.totalCouponCost,
        "discount shipping fee",
        discountShppingFee,
        "tax fee",
        tax
      );

      const paymentBody = {
        payment: {
          pid_user: this.userData.user.pid_user,
          ctg_country: settingCountryCode(this.props.i18n.language),
          typ_pay: this.props.i18n.language === "ja" ? 21 : 31,
          typ_cost: settingCountryCode(this.props.i18n.language),
          cost_pd:
            this.props.i18n.language === "en"
              ? Number((this.state.subtotal - couponFee + this.state.totalAddonCost).toFixed(2))
              : Number(this.state.subtotal + tax - couponFee + this.state.totalAddonCost),
          cost_deli:
            this.props.i18n.language === "en"
              ? Number(
                  (
                    this.deliCost.customTotalFee +
                    this.deliCost.stockTotalFee -
                    discountShppingFee
                  ).toFixed(2)
                )
              : Math.floor(
                  Number(
                    this.deliCost.customTotalFee +
                      this.deliCost.stockTotalFee -
                      discountShppingFee
                  )
                ),
          tax,
        },
        od_addr: odAddr,
        redi_url: RedicrectionUrl(),
      };
      const paymentRes = await _Fetch(paymentApi, "", paymentBody);
      console.log(paymentRes);
      const pidPayment = paymentRes.pid_payment;

      const shopOdApi =
        getItem("restAPI").model_desc.shop_user_insert_glove_order;

      const stock = this.state.data.filter((item) => item.b_custom === 2);
      const customize = this.state.data.filter((item) => item.b_custom === 1);

      console.log("data", this.state.data);

      // console.log(shopOdApi, stock, customize);

      const senderId = `${firstName}`;

      console.log("senderId", senderId);

      if (stock.length > 0 && customize.length === 0) {
        const stockRes = await this.postStockAccount(
          shopOdApi,
          pidPayment,
          stock,
          odAddr,
          senderId,
          coupon
        );
        this.orderId.push(stockRes);

        const data = {
          item: this.state.data,
          shippingAddr: this.shippingAddr,
          billingAddr: this.billingAddr,
          orderIdData: this.orderId,
          pidPayment,
          coupon,
          shippingCostData: this.deliCost,
          addonDataMap: this.state.addonDataMap,
          totalAddonCost: this.state.totalAddonCost,
          senderId,
        };

        console.log(data);
        setItem("orderReviewData", data);
        this.props.history.push("/orderReview");
      }

      if (customize.length > 0 && stock.length === 0) {
        const customRes = await this.postCustomAccount(
          shopOdApi,
          pidPayment,
          customize,
          odAddr,
          senderId,
          coupon
        );
        this.orderId.push(customRes);

        const data = {
          item: this.state.data,
          shippingAddr: this.shippingAddr,
          billingAddr: this.billingAddr,
          orderIdData: this.orderId,
          pidPayment,
          coupon,
          shippingCostData: this.deliCost,
          addonDataMap: this.state.addonDataMap,
          totalAddonCost: this.state.totalAddonCost,
          senderId,
        };

        console.log(data);
        setItem("orderReviewData", data);
        this.props.history.push("/orderReview");
      }

      if (customize.length > 0 && stock.length > 0) {
        const stockRes = await this.postStockAccount(
          shopOdApi,
          pidPayment,
          stock,
          odAddr,
          senderId,
          coupon
        );
        this.orderId.push(stockRes);
        const customRes = await this.postCustomAccount(
          shopOdApi,
          pidPayment,
          customize,
          odAddr,
          senderId,
          coupon
        );
        this.orderId.push(customRes);

        const data = {
          item: this.state.data,
          shippingAddr: this.shippingAddr,
          billingAddr: this.billingAddr,
          orderIdData: this.orderId,
          pidPayment,
          coupon,
          shippingCostData: this.deliCost,
          addonDataMap: this.state.addonDataMap,
          totalAddonCost: this.state.totalAddonCost,
          senderId,
        };

        console.log(data);
        setItem("orderReviewData", data);
        this.props.history.push("/orderReview");
        // console.log(customRes);
      }
    } catch (e) {
      console.log(e);
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        this.props.history.push("/login");
      }
    }
  }

  // 결제 시 패치 작업
  async onCheckOut(paymentType) {
    console.log(paymentType, "paymentType11111");
    try {
      const odAddr = this.shippingAddr;
      delete odAddr.date_creation;
      delete odAddr.pid_addr;
      delete odAddr.b_base;
      delete odAddr.pid_user;

      const paymentApi = getItem("restAPI").model_desc.shop_user_init_payment;

      const qty = sumQty(this.state.data);
      const isDiscountShppingFee = qty > 3;

      const shippingTotal =
        this.deliCost.customTotalFee + this.deliCost.stockTotalFee;

      const beforeDiscountShppingFee = isDiscountShppingFee
        ? shippingTotal * 0.2
        : 0;
      const discountShppingFee =
        this.props.i18n.language === "en"
          ? beforeDiscountShppingFee.toFixed(2)
          : Math.ceil(beforeDiscountShppingFee);

      const protoCouponFee = this.state.totalCouponCost;
      const couponFee =
        this.props.i18n.language === "en"
          ? protoCouponFee.toFixed(2)
          : Math.ceil(protoCouponFee);

      // OUTLIER - 20240122 - 2번
      // const tax =
      //   this.props.i18n.language === "ja"
      //     ? Math.floor(Number((this.subtotal - couponFee) * YEN_INCOM_TAX_PER))
      //     : 0;
      const tax = 0;
      //paypal 일시
      const processTypPay = (lang) => {
        console.log(processTypPay, "processTypPay");
        switch (lang) {
          case "en":
            return 10;
          case "ja":
            return 20;
          default:
            return 30;
        }
      };
      //paymentWall 일시
      const paymentWallPay = (lang) => {
        console.log(paymentWallPay, "paymentWallPay");
        switch (lang) {
          case "en":
            return 11;
          default:
            return 22;
        }
      };
      const payTpye = (type) => {
        switch (type) {
          case 1:
            return processTypPay(this.props.i18n.language);
          case 3:
            return paymentWallPay(this.props.i18n.language);
          default:
            return 32;
        }
      };

      const typPay = payTpye(paymentType);

      console.log("typPay", typPay);

      const paymentBody = {
        payment: {
          pid_user: this.userData.user.pid_user,
          ctg_country: settingCountryCode(this.props.i18n.language),
          // typ_pay: this.props.i18n.language === 'en' ? 10 : 30,
          typ_pay: typPay,
          typ_cost: settingCountryCode(this.props.i18n.language),
          cost_pd:
            this.props.i18n.language === "en"
              ? Number((this.state.subtotal - couponFee + this.state.totalAddonCost).toFixed(2))
              : Number(this.state.subtotal + tax - couponFee + this.state.totalAddonCost),
          cost_deli:
            this.props.i18n.language === "en"
              ? Number(
                  (
                    this.deliCost.customTotalFee +
                    this.deliCost.stockTotalFee -
                    discountShppingFee
                  ).toFixed(2)
                )
              : Math.floor(
                  Number(
                    this.deliCost.customTotalFee +
                      this.deliCost.stockTotalFee -
                      discountShppingFee
                  )
                ),
          tax,
        },
        od_addr: odAddr,
        redi_url: RedicrectionUrl(),
      };
      const paymentRes = await _Fetch(paymentApi, "", paymentBody);
      console.log("paymentBody", paymentBody);
      this.IMP.agency(paymentRes.imp_uid, 'NEWP1');

      const pidPayment = paymentRes.pid_payment;

      const shopOdApi =
        getItem("restAPI").model_desc.shop_user_insert_glove_order;

      const stock = this.state.data.filter((item) => item.b_custom === 2);
      const customize = this.state.data.filter((item) => item.b_custom === 1);

      // console.log(shopOdApi, stock, customize);

      if (stock.length > 0 && customize.length === 0) {
        const stockRes = await this.postStock(
          shopOdApi,
          pidPayment,
          stock,
          odAddr
        );
        this.orderId.push(stockRes);

        const data = {
          item: this.state.data,
          shippingAddr: this.shippingAddr,
          billingAddr: this.billingAddr,
          orderIdData: this.orderId,
          pidPayment,
          coupon: this.state.coupon,
          shippingCostData: this.deliCost,
          addonDataMap: this.state.addonDataMap,
          totalAddonCost: this.state.totalAddonCost,
          senderId: "",
        };

        console.log(data);
        setItem("orderReviewData", data);

        this.iamportModule(paymentRes);
      }

      if (customize.length > 0 && stock.length === 0) {
        const customRes = await this.postCustom(
          shopOdApi,
          pidPayment,
          customize,
          odAddr
        );
        this.orderId.push(customRes);

        const data = {
          item: this.state.data,
          shippingAddr: this.shippingAddr,
          billingAddr: this.billingAddr,
          orderIdData: this.orderId,
          pidPayment,
          coupon: this.state.coupon,
          shippingCostData: this.deliCost,
          addonDataMap: this.state.addonDataMap,
          totalAddonCost: this.state.totalAddonCost,
          senderId: "",
        };

        console.log(data);
        setItem("orderReviewData", data);

        this.iamportModule(paymentRes);
      }

      if (customize.length > 0 && stock.length > 0) {
        const stockRes = await this.postStock(
          shopOdApi,
          pidPayment,
          stock,
          odAddr
        );
        this.orderId.push(stockRes);
        const customRes = await this.postCustom(
          shopOdApi,
          pidPayment,
          customize,
          odAddr
        );
        this.orderId.push(customRes);

        const data = {
          item: this.state.data,
          shippingAddr: this.shippingAddr,
          billingAddr: this.billingAddr,
          orderIdData: this.orderId,
          pidPayment,
          coupon: this.state.coupon,
          shippingCostData: this.deliCost,
          addonDataMap: this.state.addonDataMap,
          totalAddonCost: this.state.totalAddonCost,
          senderId: "",
        };

        console.log(data);
        setItem("orderReviewData", data);
        // console.log(customRes);
        this.iamportModule(paymentRes);
      }
    } catch (e) {
      console.log(e);
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        this.props.history.push("/login");
      }
    }
  }

  // 사용한 쿠폰 정보 저장
  async postCouponUsed(odPdArr, odPdIdArr, odID) {
    const { coupon } = this.state;
    if (!coupon) return null;

    try {
      const api = getItem("restAPI").model_desc.coupon_used_insert;

      const promises = odPdArr.map(async (item, i) => {
        if (item.dis_value > 0) {
          console.log(item);
          const body = {
            coupon_used: {
              pid_coupon: item.pid_coupon,
              pid_od_pd: odPdIdArr[i],
              pid_user: this.userData.user.pid_user,
              id: this.userData.user.id,
              typ_coupon: item.dis_typ,
              typ_cost: item.typ_cost,
              dis_value: item.dis_value,
              pid_od: odID,
            },
          };
          console.log(body);
          return _Fetch(api, "", body);
        }
        return 0;
      });

      const promisesRes = await Promise.all(promises);
      return console.log(promisesRes);
    } catch (e) {
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        return this.props.history.push("/login");
      }
      return console.log(e);
    }
  }

  // od_pd에 커스텀 등록
  async postCustom(
    shopOdApi,
    pidPayment,
    customize,
    odAddr,
    senderId = "none"
  ) {
    const customWeight = customize.reduce(
      (a, b) => a + JSON.parse(b.body).weight,
      0
    );

    function subtotal(lanCode, data) {
      let cost = 0;
      data.map((item) => (cost += settingCost(lanCode, item) * item.quantity));
      return cost;
    }

    const customTotal = subtotal(this.props.i18n.language, customize);

    const settingGloveTypeCode = (gloveTypeStr) => {
      switch (gloveTypeStr) {
        case "Single Welting":
          return 1;
        case "Double Welting":
          return 2;
        case "First Baseman Mitt":
          return 3;
        case "Catchers Mitt":
          return 4;
        default:
          return 5;
      }
    };

    const odCustomArr = [];
    const customOdPdArr = customize.map((item) => {
      const itemBody = JSON.parse(item.body);
      odCustomArr.push({
        body: item.body,
        body_origin: item.body,
      });

      return {
        pid_user: this.userData.user.pid_user,
        pid_category: itemBody.pid_category,
        pid_pd: item.pid_item,
        title: itemBody.title,
        pd_uri: item.uri_pd,
        stage_uri: "none",
        quantity: item.quantity,
        typ_cost: settingCountryCode(this.props.i18n.language),
        cost: settingCost(this.props.i18n.language, item).toFixed(2),
        typ_glove: settingGloveTypeCode(itemBody.glove.gloveType),
        leather_grade: itemBody.glove.leatherGrade.id,

        pid_coupon:
          this.state.coupon &&
          getPerItemCouponCost(
            item,
            this.state.coupon,
            this.props.i18n.language
          ) > 0
            ? this.state.coupon.pid_coupon
            : 0,
        uuid_coupon:
          this.state.coupon &&
          getPerItemCouponCost(
            item,
            this.state.coupon,
            this.props.i18n.language
          ) > 0
            ? this.state.coupon.uuid_coupon
            : "none",
        dis_typ:
          this.state.coupon &&
          getPerItemCouponCost(
            item,
            this.state.coupon,
            this.props.i18n.language
          ) > 0
            ? this.state.coupon.typ_coupon
            : 0,
        dis_value: this.state.coupon
          ? getPerItemCouponCost(
              item,
              this.state.coupon,
              this.props.i18n.language
            )
          : 0,
        typ_delivery: itemBody.typ_delivery,
      };
    });

    const qty = sumQty(this.state.data);
    const isDiscountShppingFee = qty > 3;

    const shippingTotal = this.deliCost.customTotalFee;

    const beforeDiscountShppingFee = isDiscountShppingFee
      ? shippingTotal * 0.2
      : 0;
    const discountShppingFee =
      this.props.i18n.language === "en"
        ? beforeDiscountShppingFee.toFixed(2)
        : Math.ceil(beforeDiscountShppingFee);

    const couponFee =
      this.props.i18n.language === "en"
        ? this.calCouponCost(this.state.coupon, customize).toFixed(2)
        : Math.ceil(this.calCouponCost(this.state.coupon, customize));

    // OUTLIER - 20240122 - 2번
    // const tax =
    //   this.props.i18n.language === "ja"
    //     ? Math.floor(Number((customTotal - couponFee) * YEN_INCOM_TAX_PER))
    //     : 0;
    const tax = 0;

    // 추가옵션 데이터 준비 (od_pd_arr와 동일한 인덱스로 매칭)
    const { addonDataMap, totalAddonCost } = this.state;
    const odAddonArr = customize.map((item) => {
      const cartKey = item.pid_cart || item.pid_item;
      const addonData = addonDataMap[cartKey];
      if (addonData && Array.isArray(addonData.addons) && addonData.addons.length > 0) {
        // 옵션별 주문 시점 스냅샷. addon_cost 계산과 같은 소스(getAddonPrice)라 합계 불일치 불가
        const lang = this.props.i18n.language;
        return {
          addon_items: addonData.addons.map((a) => ({
            pid_addon: a.pid_addon,
            title: getAddonTitle(a, lang) || 'Add-on Option',
            unit_price: getAddonPrice(a, lang),
          })),
          addon_request: addonData.addon_request || '',
          addon_ref_img: addonData.addon_ref_imgs ? addonData.addon_ref_imgs.map(img => img.url).join(',') : '',
          addon_cost: addonData.addon_cost || 0,
          pid_cart_addon: addonData.pid_cart_addon,
        };
      }
      return null;
    });

    const customBody = {
      od: {
        pid_payment: pidPayment,
        pid_user: this.userData.user.pid_user,
        ctg_pd: 1,
        id: this.userData.user.id,
        user_name: `${this.shippingAddr.name_first} ${this.shippingAddr.name_last}`,
        typ_cost: settingCountryCode(this.props.i18n.language),
        // 추가옵션 비용은 할인 적용 안됨
        cost_pd:
          this.props.i18n.language === "en"
            ? Number((this.state.subtotal - couponFee + totalAddonCost).toFixed(2))
            : Number(this.state.subtotal + tax - couponFee + totalAddonCost),
        cost_deli:
          this.props.i18n.language === "en"
            ? Number(
                (
                  this.deliCost.customTotalFee +
                  this.deliCost.stockTotalFee -
                  discountShppingFee
                ).toFixed(2)
              )
            : Math.floor(
                Number(
                  this.deliCost.customTotalFee +
                    this.deliCost.stockTotalFee -
                    discountShppingFee
                )
              ),
        tax,
        // uid_tracking: shortid.generate(),
        // via_delivery: 'test',
        shipping: `weight: ${customWeight}`,
        cnt_item: customize.length,
        title: JSON.parse(customize[0].body).title,
        sender_name: senderId,
      },
      od_addr: odAddr,
      od_pd_arr: customOdPdArr,
      od_cust_arr: odCustomArr,
      od_addon_arr: odAddonArr,
    };

    // console.log('custom', customBody);
    try {
      const res = await _Fetch(shopOdApi, "", customBody);
      // console.log('custom', res);
      await this.postCouponUsed(customOdPdArr, res.pd_arr, res.od);
      return res;
      // return _Fetch(shopOdApi, '', customBody);
    } catch (e) {
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        return this.props.history.push("/login");
      }
      return e;
    }
  }

  // 기성품 od_pd 에 등록
  async postStock(shopOdApi, pidPayment, stock, odAddr, senderId = "none") {
    const stockWeight = stock.reduce(
      (a, b) => a + JSON.parse(b.body).weight,
      0
    );

    console.log("stock", stock);

    function subtotal(lanCode, data) {
      let cost = 0;
      data.map((item) => (cost += settingCost(lanCode, item) * item.quantity));
      return cost;
    }

    const stockTotal = subtotal(this.props.i18n.language, stock);

    const odCustomArr = [];
    const stockOdPdArr = stock.map((item) => {
      const itemBody = JSON.parse(item.body);
      // const optBody = itemBody.options.length === 0 ? JSON.stringify('none') : JSON.stringify(itemBody.options);
      odCustomArr.push({
        body: item.body,
        body_origin: item.body,
      });
      return {
        pid_user: this.userData.user.pid_user,
        pid_category: itemBody.pid_category,
        pid_pd: item.pid_item,
        title: itemBody.title,
        pd_uri: item.uri_pd,
        quantity: item.quantity,
        typ_cost: settingCountryCode(this.props.i18n.language),
        cost: settingCost(this.props.i18n.language, item).toFixed(2),

        pid_coupon:
          this.state.coupon &&
          getPerItemCouponCost(
            item,
            this.state.coupon,
            this.props.i18n.language
          ) > 0
            ? this.state.coupon.pid_coupon
            : 0,
        uuid_coupon:
          this.state.coupon &&
          getPerItemCouponCost(
            item,
            this.state.coupon,
            this.props.i18n.language
          ) > 0
            ? this.state.coupon.uuid_coupon
            : "none",
        dis_typ:
          this.state.coupon &&
          getPerItemCouponCost(
            item,
            this.state.coupon,
            this.props.i18n.language
          ) > 0
            ? this.state.coupon.typ_coupon
            : 0,
        dis_value: this.state.coupon
          ? getPerItemCouponCost(
              item,
              this.state.coupon,
              this.props.i18n.language
            )
          : 0,

        typ_delivery: itemBody.typ_delivery,
        pid_pd_inv: itemBody.pid_pd_inv,
      };
    });

    const qty = sumQty(this.state.data);
    const isDiscountShppingFee = qty > 3;

    const shippingTotal = this.deliCost.stockTotalFee;

    const beforeDiscountShppingFee = isDiscountShppingFee
      ? shippingTotal * 0.2
      : 0;
    const discountShppingFee =
      this.props.i18n.language === "en"
        ? beforeDiscountShppingFee.toFixed(2)
        : Math.ceil(beforeDiscountShppingFee);

    const couponFee =
      this.props.i18n.language === "en"
        ? this.calCouponCost(this.state.coupon, stock).toFixed(2)
        : Math.ceil(this.calCouponCost(this.state.coupon, stock));

    // OUTLIER - 20240122 - 2번
    // const tax =
    //   this.props.i18n.language === "ja"
    //     ? Math.floor(Number((stockTotal - couponFee) * YEN_INCOM_TAX_PER))
    //     : 0;
    const tax = 0;

    const stockBody = {
      od: {
        pid_payment: pidPayment,
        pid_user: this.userData.user.pid_user,
        ctg_pd: 2,
        id: this.userData.user.id,
        user_name: `${this.shippingAddr.name_first} ${this.shippingAddr.name_last}`,
        typ_cost: settingCountryCode(this.props.i18n.language),
        cost_pd:
          this.props.i18n.language === "en"
            ? Number((this.state.subtotal - couponFee).toFixed(2))
            : Number(this.state.subtotal + tax - couponFee),
        cost_deli:
          this.props.i18n.language === "en"
            ? Number(
                (
                  this.deliCost.customTotalFee +
                  this.deliCost.stockTotalFee -
                  discountShppingFee
                ).toFixed(2)
              )
            : Math.floor(
                Number(
                  this.deliCost.customTotalFee +
                    this.deliCost.stockTotalFee -
                    discountShppingFee
                )
              ),
        tax,
        // uid_tracking: shortid.generate(),
        // via_delivery: 'test',
        shipping: `weight: ${stockWeight}`,
        cnt_item: stock.length,
        title: JSON.parse(stock[0].body).title,
        sender_name: senderId,
      },
      od_addr: odAddr,
      od_pd_arr: stockOdPdArr,
      od_cust_arr: odCustomArr,
    };

    try {
      // console.log('stock', stockBody);
      const res = await _Fetch(shopOdApi, "", stockBody);
      // console.log('stock', res);
      await this.postCouponUsed(stockOdPdArr, res.pd_arr, res.od);
      return res;
      // return _Fetch(shopOdApi, '', stockBody);
    } catch (e) {
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        return this.props.history.push("/login");
      }
      return e;
    }
  }

  // od_pd에 커스텀 등록
  async postCustomAccount(
    shopOdApi,
    pidPayment,
    customize,
    odAddr,
    senderId,
    coupon
  ) {
    const customWeight = customize.reduce(
      (a, b) => a + JSON.parse(b.body).weight,
      0
    );

    function subtotal(lanCode, data) {
      let cost = 0;
      data.map((item) => (cost += settingCost(lanCode, item) * item.quantity));
      return cost;
    }

    const customTotal = subtotal(this.props.i18n.language, customize);

    const settingGloveTypeCode = (gloveTypeStr) => {
      switch (gloveTypeStr) {
        case "Single Welting":
          return 1;
        case "Double Welting":
          return 2;
        case "First Baseman Mitt":
          return 3;
        case "Catchers Mitt":
          return 4;
        default:
          return 5;
      }
    };

    const odCustomArr = [];
    const customOdPdArr = customize.map((item) => {
      const itemBody = JSON.parse(item.body);
      odCustomArr.push({
        body: item.body,
        body_origin: item.body,
      });

      return {
        pid_user: this.userData.user.pid_user,
        pid_category: itemBody.pid_category,
        pid_pd: item.pid_item,
        title: itemBody.title,
        pd_uri: item.uri_pd,
        stage_uri: "none",
        quantity: item.quantity,
        typ_cost: settingCountryCode(this.props.i18n.language),
        cost: settingCost(this.props.i18n.language, item).toFixed(2),
        typ_glove: settingGloveTypeCode(itemBody.glove.gloveType),
        leather_grade: itemBody.glove.leatherGrade.id,

        pid_coupon:
          coupon &&
          getPerItemCouponCost(item, coupon, this.props.i18n.language) > 0
            ? coupon.pid_coupon
            : 0,
        uuid_coupon:
          coupon &&
          getPerItemCouponCost(item, coupon, this.props.i18n.language) > 0
            ? coupon.uuid_coupon
            : "none",
        dis_typ:
          coupon &&
          getPerItemCouponCost(item, coupon, this.props.i18n.language) > 0
            ? coupon.typ_coupon
            : 0,
        dis_value: coupon
          ? getPerItemCouponCost(item, coupon, this.props.i18n.language)
          : 0,
        typ_delivery: itemBody.typ_delivery,
      };
    });

    const qty = sumQty(this.state.data);
    const isDiscountShppingFee = qty > 3;

    const shippingTotal = this.deliCost.customTotalFee;

    const beforeDiscountShppingFee = isDiscountShppingFee
      ? shippingTotal * 0.2
      : 0;
    const discountShppingFee =
      this.props.i18n.language === "en"
        ? beforeDiscountShppingFee.toFixed(2)
        : Math.ceil(beforeDiscountShppingFee);

    const couponFee =
      this.props.i18n.language === "en"
        ? this.calCouponCost(coupon, customize).toFixed(2)
        : Math.ceil(this.calCouponCost(coupon, customize));

    //  OUTLIER - 20240122 - 2번
    // const tax =
    //   this.props.i18n.language === "ja"
    //     ? Math.floor(Number((customTotal - couponFee) * YEN_INCOM_TAX_PER))
    //     : 0;
    const tax = 0;

    // 추가옵션 데이터 준비 (od_pd_arr와 동일한 인덱스로 매칭)
    const { addonDataMap, totalAddonCost } = this.state;
    const odAddonArr = customize.map((item) => {
      const cartKey = item.pid_cart || item.pid_item;
      const addonData = addonDataMap[cartKey];
      if (addonData && Array.isArray(addonData.addons) && addonData.addons.length > 0) {
        // 옵션별 주문 시점 스냅샷. addon_cost 계산과 같은 소스(getAddonPrice)라 합계 불일치 불가
        const lang = this.props.i18n.language;
        return {
          addon_items: addonData.addons.map((a) => ({
            pid_addon: a.pid_addon,
            title: getAddonTitle(a, lang) || 'Add-on Option',
            unit_price: getAddonPrice(a, lang),
          })),
          addon_request: addonData.addon_request || '',
          addon_ref_img: addonData.addon_ref_imgs ? addonData.addon_ref_imgs.map(img => img.url).join(',') : '',
          addon_cost: addonData.addon_cost || 0,
          pid_cart_addon: addonData.pid_cart_addon,
        };
      }
      return null;
    });

    const customBody = {
      od: {
        pid_payment: pidPayment,
        pid_user: this.userData.user.pid_user,
        ctg_pd: 1,
        id: this.userData.user.id,
        user_name: `${this.shippingAddr.name_first} ${this.shippingAddr.name_last}`,
        typ_cost: settingCountryCode(this.props.i18n.language),
        // 추가옵션 비용은 할인 적용 안됨
        cost_pd:
          this.props.i18n.language === "en"
            ? Number((this.state.subtotal - couponFee + totalAddonCost).toFixed(2))
            : Number(this.state.subtotal + tax - couponFee + totalAddonCost),
        cost_deli:
          this.props.i18n.language === "en"
            ? Number(
                (
                  this.deliCost.customTotalFee +
                  this.deliCost.stockTotalFee -
                  discountShppingFee
                ).toFixed(2)
              )
            : Math.floor(
                Number(
                  this.deliCost.customTotalFee +
                    this.deliCost.stockTotalFee -
                    discountShppingFee
                )
              ),
        tax,
        // uid_tracking: shortid.generate(),
        // via_delivery: 'test',
        shipping: `weight: ${customWeight}`,
        cnt_item: customize.length,
        title: JSON.parse(customize[0].body).title,
        sender_name: senderId,
      },
      od_addr: odAddr,
      od_pd_arr: customOdPdArr,
      od_cust_arr: odCustomArr,
      od_addon_arr: odAddonArr,
    };

    // console.log('custom', customBody);
    try {
      const res = await _Fetch(shopOdApi, "", customBody);
      // console.log('custom', res);
      await this.postCouponUsed(customOdPdArr, res.pd_arr, res.od);
      return res;
      // return _Fetch(shopOdApi, '', customBody);
    } catch (e) {
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        return this.props.history.push("/login");
      }
      return e;
    }
  }

  // 기성품 od_pd 에 등록
  async postStockAccount(
    shopOdApi,
    pidPayment,
    stock,
    odAddr,
    senderId,
    coupon
  ) {
    const stockWeight = stock.reduce(
      (a, b) => a + JSON.parse(b.body).weight,
      0
    );

    console.log("stock", stock);

    function subtotal(lanCode, data) {
      let cost = 0;
      data.map((item) => (cost += settingCost(lanCode, item) * item.quantity));
      return cost;
    }

    const stockTotal = subtotal(this.props.i18n.language, stock);

    const odCustomArr = [];
    const stockOdPdArr = stock.map((item) => {
      const itemBody = JSON.parse(item.body);
      // const optBody = itemBody.options.length === 0 ? JSON.stringify('none') : JSON.stringify(itemBody.options);
      odCustomArr.push({
        body: item.body,
        body_origin: item.body,
      });
      return {
        pid_user: this.userData.user.pid_user,
        pid_category: itemBody.pid_category,
        pid_pd: item.pid_item,
        title: itemBody.title,
        pd_uri: item.uri_pd,
        quantity: item.quantity,
        typ_cost: settingCountryCode(this.props.i18n.language),
        cost: settingCost(this.props.i18n.language, item).toFixed(2),

        pid_coupon:
          coupon &&
          getPerItemCouponCost(item, coupon, this.props.i18n.language) > 0
            ? coupon.pid_coupon
            : 0,
        uuid_coupon:
          coupon &&
          getPerItemCouponCost(item, coupon, this.props.i18n.language) > 0
            ? coupon.uuid_coupon
            : "none",
        dis_typ:
          coupon &&
          getPerItemCouponCost(item, coupon, this.props.i18n.language) > 0
            ? coupon.typ_coupon
            : 0,
        dis_value: coupon
          ? getPerItemCouponCost(item, coupon, this.props.i18n.language)
          : 0,

        typ_delivery: itemBody.typ_delivery,
        pid_pd_inv: itemBody.pid_pd_inv,
      };
    });

    const qty = sumQty(this.state.data);
    const isDiscountShppingFee = qty > 3;

    const shippingTotal = this.deliCost.stockTotalFee;

    const beforeDiscountShppingFee = isDiscountShppingFee
      ? shippingTotal * 0.2
      : 0;
    const discountShppingFee =
      this.props.i18n.language === "en"
        ? beforeDiscountShppingFee.toFixed(2)
        : Math.ceil(beforeDiscountShppingFee);

    const couponFee =
      this.props.i18n.language === "en"
        ? this.calCouponCost(coupon, stock).toFixed(2)
        : Math.ceil(this.calCouponCost(coupon, stock));

    // OUTLIER - 20240122 - 2번
    // const tax =
    //   this.props.i18n.language === "ja"
    //     ? Math.floor(Number((stockTotal - couponFee) * YEN_INCOM_TAX_PER))
    //     : 0;
    const tax = 0;

    const stockBody = {
      od: {
        pid_payment: pidPayment,
        pid_user: this.userData.user.pid_user,
        ctg_pd: 2,
        id: this.userData.user.id,
        user_name: `${this.shippingAddr.name_first} ${this.shippingAddr.name_last}`,
        typ_cost: settingCountryCode(this.props.i18n.language),
        cost_pd:
          this.props.i18n.language === "en"
            ? Number((this.state.subtotal - couponFee).toFixed(2))
            : Number(this.state.subtotal + tax - couponFee),
        cost_deli:
          this.props.i18n.language === "en"
            ? Number(
                (
                  this.deliCost.customTotalFee +
                  this.deliCost.stockTotalFee -
                  discountShppingFee
                ).toFixed(2)
              )
            : Math.floor(
                Number(
                  this.deliCost.customTotalFee +
                    this.deliCost.stockTotalFee -
                    discountShppingFee
                )
              ),
        tax,
        // uid_tracking: shortid.generate(),
        // via_delivery: 'test',
        shipping: `weight: ${stockWeight}`,
        cnt_item: stock.length,
        title: JSON.parse(stock[0].body).title,
        sender_name: senderId,
      },
      od_addr: odAddr,
      od_pd_arr: stockOdPdArr,
      od_cust_arr: odCustomArr,
    };

    try {
      // console.log('stock', stockBody);
      const res = await _Fetch(shopOdApi, "", stockBody);
      // console.log('stock', res);
      await this.postCouponUsed(stockOdPdArr, res.pd_arr, res.od);
      return res;
      // return _Fetch(shopOdApi, '', stockBody);
    } catch (e) {
      if (e.status === 1164) {
        this.openModal(
          "Your login information is invalid. Please login again."
        );
        setCookie("userData", "", -1);
        return this.props.history.push("/login");
      }
      return e;
    }
  }

  async onCoupon() {
    // console.log(this.couponInput.value);
    if (!this.couponInput || !this.couponInput.value) {
      return this.openModal("Please, set coupon code.");
    }

    try {
      console.log("request coupon api");
      const api = getItem("restAPI").model_desc.shop_user_search_coupon_name;
      const res = await _Fetch(api, `?str=${this.couponInput.value}`, []);
      console.log("coupon", res, res.length);

      if (res.length === 0) {
        return this.setState({ coupon: res[0] }, () =>
          this.openModal("The coupon code entered is invalid.")
        );
      }

      return this.calCouponTotalCost(res[0]);
    } catch (e) {
      console.log("err", e);
      if (e.status === 1261) {
        return alert("exceed limit coupon used");
      }
      if (e.status === 1260) {
        return alert("exceed coupon expiary time");
      }
      return alert(e.results);
    }
  }

  // coupon total Cost
  calCouponTotalCost(couponData) {
    if (!couponData) return null;

    // 아이템 마다 쿠폰 가격 저장 되어있는 배멸
    const couponTotalCostArr = this.state.data.map(
      (item) =>
        getPerItemCouponCost(item, couponData, this.props.i18n.language) *
        item.quantity
    );

    console.log("couponTotalCostArr", couponTotalCostArr);

    // 배열에 있는 값들 합산
    const couponTotalCost = couponTotalCostArr.reduce((a, b) => a + b, 0);

    console.log("couponTotalCost", couponTotalCost);

    if (couponTotalCost === 0) {
      return alert("No coupons apply.");
    }

    // console.log(couponTotalCost, couponTotalCostArr);
    return this.setState(
      {
        totalCouponCost: couponTotalCost,
        coupon: couponData,
      },
      () => this.openModal("The coupon has been applied.")
    );
  }

  calCouponCost(couponData, data) {
    if (!couponData) return 0;

    // 아이템 마다 쿠폰 가격 저장 되어있는 배멸
    const couponTotalCostArr = data.map(
      (item) =>
        getPerItemCouponCost(item, couponData, this.props.i18n.language) *
        item.quantity
    );

    // 배열에 있는 값들 합산
    const couponTotalCost = couponTotalCostArr.reduce((a, b) => a + b, 0);
    // console.log(couponTotalCost, couponTotalCostArr);
    return couponTotalCost;
  }

  renderEmpty() {
    return (
      <div>
        <p style={styles.itemBoxNotice}>There are no items in your cart.</p>
        <DivButton
          style={styles.goShoppingBtn}
          onClick={() => this.props.history.push("/shop")}
        >
          <p style={styles.goShoppingTitle}>GO SHOPPING</p>
          <img src={arrowWhite} style={styles.goShoppingArrow} alt="w_arrow" />
        </DivButton>
      </div>
    );
  }

  renderItem(data) {
    const { addonDataMap, highlightAddonButtons } = this.state;
    return data.map((item, i) => {
      const cartKey = item.pid_cart || item.pid_item;
      const addonData = addonDataMap[cartKey] || null;
      const hasAddon = addonData && (addonData.addon_ids?.length > 0 || addonData.addon_cost > 0);

      return (
        <Item
          onCalculation={(inputQty) => this.onCalculation(item, inputQty, i)}
          quantity={item.quantity}
          coupon={this.state.coupon}
          data={item}
          onViewDtail={async () => {
            await setTimeout(() => window.scrollTo(0, 0), 1);
            this.viewDetailData = item;
            this.setState({ isViewDetailModal: true });
          }}
          key={shortid.generate()}
          marginBottom={i === data.length - 1 ? 33 : 40}
          onDelete={() => this.onDelete(item, i)}
          // 추가옵션 관련 props
          onAddOptions={() => this.openAddonModal(item)}
          hasAddon={hasAddon}
          highlightAddon={highlightAddonButtons && item.b_custom === 1 && !hasAddon}
          addonData={addonData}
        />
      );
    });
  }

  renderSubTotal = (lang) => {
    switch (lang) {
      case "en":
        return returnComma(Number(this.state.subtotal).toFixed(2));
      case "ja":
        return returnComma(Number(this.state.subtotal));
      // return returnComma(Number(this.state.subtotal) + Number(this.state.subtotal) * YEN_INCOM_TAX_PER);
      default:
        return returnComma(Number(this.state.subtotal));
    }
  };

  renderTerms = () => {
    const lang = window.localStorage.getItem("i18nextLng");
    switch (lang) {
      case "en":
        return (
          <div>
            <p style={styles.footerNotice}>
              By continuing, you agree to Gloveworks’
            </p>
            <div style={styles.footerSubNotice}>
              <div
                role="button"
                tabIndex="-1"
                onClick={() => this.setState({ isModal: true })}
                style={styles.bluePointText}
              >
                Terms of Service
              </div>
              <p style={styles.normalText}>&nbsp;and&nbsp;</p>
              <div
                role="button"
                tabIndex="-1"
                onClick={() => this.setState({ isPolicyModal: true })}
                style={styles.bluePointText}
              >
                Privacy Policy
              </div>
            </div>
          </div>
        );
      case "ja":
        return (
          <div>
            <div style={styles.footerSubNoticeJp}>
              <div
                role="button"
                tabIndex="-1"
                onClick={() =>
                  this.props.i18n.language === "en"
                    ? this.setState({ isModal: true })
                    : window.open("https://www.gloveworks.net/termsOfService")
                }
                style={styles.bluePointText}
              >
                利用規約
              </div>
              <p style={styles.normalText}>と</p>
              <div
                role="button"
                tabIndex="-1"
                onClick={() =>
                  this.props.i18n.language === "en"
                    ? this.setState({ isPolicyModal: true })
                    : window.open("https://www.gloveworks.net/privacyPolicy")
                }
                style={styles.bluePointText}
              >
                個人情報保護方針
              </div>
              <p style={styles.normalText}>に同意します。</p>
            </div>
          </div>
        );
      // return returnComma(Number(this.state.subtotal) + Number(this.state.subtotal) * YEN_INCOM_TAX_PER);
      default:
        return (
          <div>
            <p style={styles.footerNotice}>주문진행을 함으로써 글러브웍스의</p>
            <div style={styles.footerSubNotice}>
              <div
                role="button"
                tabIndex="-1"
                onClick={() =>
                  this.props.i18n.language === "en"
                    ? this.setState({ isModal: true })
                    : window.open("https://www.gloveworks.net/termsOfService")
                }
                style={styles.bluePointText}
              >
                이용약관
              </div>
              <p style={styles.normalText}>과&nbsp;</p>
              <div
                role="button"
                tabIndex="-1"
                onClick={() =>
                  this.props.i18n.language === "en"
                    ? this.setState({ isPolicyModal: true })
                    : window.open("https://www.gloveworks.net/privacyPolicy")
                }
                style={styles.bluePointText}
              >
                개인정보처리방침
              </div>
            </div>
            <p style={styles.footerNoticeJp}>에 동의합니다.</p>
          </div>
        );
    }
  };

  renderSummaryBox() {
    const { t } = this.props;
    return (
      <div className="cart-summary-box" style={styles.summaryBox(this.state.totalCouponCost > 0)}>
        <p style={styles.summaryTitle}>SUMMARY</p>

        <div className="cart-coupon-input-box" style={styles.couponInputBox}>
          {this.state.coupon ? (
            <img style={styles.couponCheckImg} src={couponCheck} alt="" />
          ) : null}
          <Input
            ref={(couponInput) => (this.couponInput = couponInput)}
            placeholder={t("cartCouponCode")}
            onChange={(value) => (this.couponInput.value = value)}
            type="text"
            style={styles.couponInputStyle(
              setCouponInputBorderColor(this.state.coupon)
            )}
            placeholderColor="#c8c8c8"
          />
        </div>

        <div style={styles.applyBox}>
          <DivButton
            style={styles.applyCouponBtn}
            onClick={() => this.onCoupon()}
          >
            {t("cartApplyCoupon")}
          </DivButton>
          <DivButton
            style={styles.closeBtn}
            onClick={() => {
              if (this.couponInput) {
                this.couponInput.value = "";
              }
              this.setState({
                coupon: null,
                totalCouponCost: 0,
              });
            }}
          >
            <img src={close} alt="" style={styles.closeImg} />
          </DivButton>
        </div>

        <div style={styles.couponNoticeTextBox}>{t("cartDesc")}</div>

        <div style={styles.underline(24)} />

        <div style={styles.costBox(16)}>
          <p style={styles.cartTotalText}>{t("cartTotal")}</p>
          <p style={styles.cartTotalText}>
            {checkedCurrencySymbol(this.props.i18n.language)}
            {this.renderSubTotal(this.props.i18n.language)}
          </p>
        </div>

        {this.state.totalCouponCost > 0 ? (
          <div style={styles.costBox(8)}>
            <p style={{ ...styles.cartTotalText, color: "#d0021b" }}>
              Coupon Discount
            </p>
            <p style={{ ...styles.cartTotalText, color: "#d0021b" }}>
              -{checkedCurrencySymbol(this.props.i18n.language)}
              {this.props.i18n.language === "en"
                ? returnComma(Number(this.state.totalCouponCost).toFixed(2))
                : returnComma(Number(this.state.totalCouponCost))}
            </p>
          </div>
        ) : null}

        {/* 추가옵션 비용 표시 - 할인 적용 안됨 */}
        {this.state.totalAddonCost > 0 ? (
          <div style={styles.costBox(8)}>
            <p style={{ ...styles.cartTotalText, color: "#c77b46" }}>
              {t("addonOptions") || "Add-on Options"}
            </p>
            <p style={{ ...styles.cartTotalText, color: "#c77b46" }}>
              +{checkedCurrencySymbol(this.props.i18n.language)}
              {this.props.i18n.language === "en"
                ? returnComma(Number(this.state.totalAddonCost).toFixed(2))
                : returnComma(Number(this.state.totalAddonCost))}
            </p>
          </div>
        ) : null}

        <div style={styles.costBox(8)}>
          <p style={styles.totalText}>{t("cartSubTotal")}</p>
          <p style={styles.totalText}>
            {checkedCurrencySymbol(this.props.i18n.language)}
            {this.props.i18n.language === "en"
              ? returnComma(
                  (
                    Number(this.state.subtotal) - this.state.totalCouponCost + this.state.totalAddonCost
                  ).toFixed(2)
                )
              : returnComma(
                  Number(this.state.subtotal) - this.state.totalCouponCost + this.state.totalAddonCost
                )}
          </p>
        </div>

        <div style={styles.noticeBox}>
          <img alt="" style={styles.helpImg} src={info} />
          <p style={styles.noticeText}>{t("cartTaxDesc")}</p>
        </div>

        <div style={styles.underline(16)} />

        <div className="cart-policy-box" style={styles.policeBox}>
          <CheckInput getChecked={(value) => (this.checkArr[0] = value)} />
          {this.renderTerms()}
        </div>

        <div className="cart-policy-bottom-box" style={styles.policeBottomBox}>
          <CheckInput getChecked={(value) => (this.checkArr[1] = value)} />
          <p style={styles.normalBottomText}>{t("cartAgree")}</p>
        </div>

        <DivButton
          style={styles.checkoutBtnBox}
          onClick={async () => {
            //이후 그대로진행
            if (!this.checkArr[0] || !this.checkArr[1]) {
              return this.openModal("Please check all check boxes.");
            }

            if (!this.userData) return this.props.history.push("/login");
            console.log(this.state.data);
            if (
              this.state.data.length === 1 &&
              JSON.parse(this.state.data[0].body).typ_delivery === 4
            ) {
              return this.openModal("Oils can not be purchased separately.");
            }

            const oilData = this.state.data.filter(
              (item) => JSON.parse(item.body).typ_delivery === 4
            );

            if (oilData.length > 1) {
              return this.openModal("Only one kind of oil can be purchased");
            }

            if (oilData.length > 0 && oilData[0].quantity > 3) {
              return this.openModal("You can not purchase more than 3 oils.");
            }

            // 커스터마이즈 상품 중 추가옵션이 없는 아이템이 있으면 확인 팝업 표시
            if (this.hasCustomItemWithoutAddon()) {
              return this.openAddonConfirmModal();
            }

            //결제전 세팅된 시간안에 이미 결제한 내역인지 체크
            let isExist = "false";
            const api =
              getItem("restAPI").model_desc
                .shop_user_check_previous_payment_log;
            const prepaidRes = await _Fetch(
              api,
              `?pid_user=${this.userData.user.pid_user}`,
              []
            );

            // console.log(res);
            console.log("previous check res : ", prepaidRes);
            if (prepaidRes == "true") return this.openPrepaidModal();

            if (this.userData && this.state.data.length > 0) {
              return this.setState({ step: 1 });
            }
            return this.openModal("Please include at least one item.");
          }}
        >
          <p style={styles.checkoutTitle}>{t("cartCheckOut")}</p>
          <img src={arrowWhite} style={styles.goShoppingArrow} alt="w_arrow" />
        </DivButton>
      </div>
    );
  }

  renderTermsOfServiceModal() {
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.state.isModal}
        contentLabel="Add New Address"
        onRequestClose={() => this.setState({ isModal: false })}
        style={AddressModalStyles}
      >
        <p style={styles.modalTitle}>Terms of Service</p>

        <div
          tabIndex="-1"
          role="button"
          onClick={() => this.setState({ isModal: false })}
          style={styles.noticeModalImg}
        >
          <img alt="" src={close} />
        </div>

        <Notice />
      </Modal>
    );
  }

  renderPolicyModal() {
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.state.isPolicyModal}
        contentLabel="Add New Address"
        onRequestClose={() => this.setState({ isPolicyModal: false })}
        style={AddressModalStyles}
      >
        <p style={styles.modalTitle}>Privacy Policy</p>

        <div
          tabIndex="-1"
          role="button"
          onClick={() => this.setState({ isPolicyModal: false })}
          style={styles.noticeModalImg}
        >
          <img alt="" src={close} />
        </div>

        <NoticePolicy />
      </Modal>
    );
  }

  // 결제 진행 까지 SPA로 구성
  render() {
    const { isModal2, bodyText2, isPrepaidModal } = this.state;
    if (isModal2) {
      return (
        <Modal2
          isModal={isModal2}
          bodyText={bodyText2}
          onClose={this.closeModal}
          onNext={this.onNext}
        />
      );
    }

    if (isPrepaidModal) {
      return (
        <ConfirmModal
          isModal={isPrepaidModal}
          bodyText={this.props.t("cartCheckPrepaid")}
          leftBtnText={this.props.t("cartCheckPrepaidLeft")}
          rightBtnText={this.props.t("cartCheckPrepaidRight")}
          onClose={this.closePrepaidModal}
          onNext={this.onPrepaidNext}
          leftBtn={this.prepaidModalLeftBtn}
          rightBtn={(checkAddr, billingAddr, deliCost, shippingNode) => {
            console.log("right Btn Click");
            this.setState({
              isPrepaidModal: false,
              bodyPrepaidText: "",
              step: 1,
            });
          }}
        />
      );
    }

    if (this.state.step === 1) {
      return (
        <ShippingInfo
          itemData={this.state.data}
          onNext={(checkAddr, billingAddr, deliCost, shippingNode) => {
            this.shippingAddr = checkAddr;
            this.billingAddr = billingAddr;
            this.deliCost = deliCost;
            this.setState({ step: 2 });
            this.shippingNode = shippingNode;
          }}
        />
      );
    }
    if (this.state.step === 2) {
      return (
        <PaymentInfo
          data={this.state.data}
          couponData={this.state.coupon}
          addonDataMap={this.state.addonDataMap}
          totalAddonCost={this.state.totalAddonCost}
          onCheckOut={(paymentType, firstName) =>
            paymentType === 2
              ? this.onManageStateAccChkOut(firstName)
              : this.onCheckOut(paymentType)
          }
          onPreview={() => this.setState({ step: 1 })}
          shippingData={this.deliCost}
          addressData={{
            shippingAddr: this.shippingAddr,
            billingAddr: this.billingAddr,
          }}
          shippingNode={this.shippingNode}
        />
      );
    }
    // console.log(this.state.data);
    if (!this.state.data) {
      return <div style={styles.emptyContainer} />;
    }

    return (
      <div className="cart-page">
        {!this.viewDetailData ? null : (
          <ConfirmCartModal
            data={this.viewDetailData}
            isModal={this.state.isViewDetailModal}
            onClose={() => {
              this.viewDetailData = null;
              // document.body.style.overflow = 'auto';
              this.setState({ isViewDetailModal: false });
            }}
          />
        )}

        {this.state.isModal ? this.renderTermsOfServiceModal() : null}
        {this.state.isPolicyModal ? this.renderPolicyModal() : null}

        {/* 추가옵션 선택 모달 */}
        {this.state.isAddonModal && this.state.selectedCartItem && (
          <AddOnOptionModal
            isModal={this.state.isAddonModal}
            onClose={this.closeAddonModal}
            onConfirm={this.handleAddonConfirm}
            existingAddons={
              this.state.addonDataMap[
                this.state.selectedCartItem.pid_cart ||
                  this.state.selectedCartItem.pid_item
              ]?.addons || []
            }
            existingRequest={
              this.state.addonDataMap[
                this.state.selectedCartItem.pid_cart ||
                  this.state.selectedCartItem.pid_item
              ]?.addon_request || ''
            }
            existingImages={
              this.state.addonDataMap[
                this.state.selectedCartItem.pid_cart ||
                  this.state.selectedCartItem.pid_item
              ]?.addon_ref_imgs || []
            }
          />
        )}

        {/* 추가옵션 확인 팝업 */}
        {this.state.isAddonConfirmModal && (
          <AddonConfirmModal
            isModal={this.state.isAddonConfirmModal}
            onClose={this.closeAddonConfirmModal}
            onAddOptions={() => {
              this.closeAddonConfirmModal();
              // 첫 번째 추가옵션 없는 커스텀 아이템의 모달 열기
              const customItems = this.getCustomItemsWithAddonStatus();
              const itemWithoutAddon = customItems.find(item => !item.addonData);
              if (itemWithoutAddon) {
                this.openAddonModal(itemWithoutAddon);
              }
            }}
            onProceed={async () => {
              this.closeAddonConfirmModal();
              // 결제 진행
              const api =
                getItem("restAPI").model_desc
                  .shop_user_check_previous_payment_log;
              const prepaidRes = await _Fetch(
                api,
                `?pid_user=${this.userData.user.pid_user}`,
                []
              );
              if (prepaidRes == "true") return this.openPrepaidModal();
              if (this.userData && this.state.data.length > 0) {
                return this.setState({ step: 1 });
              }
            }}
            customItems={this.getCustomItemsWithAddonStatus()}
          />
        )}

        <Step menu={STEP_MENU} />

        <div className="cart-inner-container" style={styles.innerContainer}>
          <div className="cart-item-box" style={styles.emptyItemBox(this.state.data.length === 0)}>
            <div
              className="cart-item-box-title"
              style={styles.ItemBoxTitle}
            >{`MY CART(${this.state.data.length})`}</div>
            {this.state.data.length === 0
              ? this.renderEmpty()
              : this.renderItem(this.state.data)}
          </div>
          {this.renderSummaryBox()}
        </div>
      </div>
    );
  }
}

const AddressModalStyles = {
  content: {
    width: 960,
    height: 640,
    backgroundColor: "#fff",
    border: "solid 1px rgba(21, 41, 53, 0.1)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: 0,
    borderRadius: 8,
  },
};

const styles = {
  emptyContainer: {
    width: "100%",
    height: 1300,
  },
  innerContainer: {
    display: "flex",
    width: "100%",
    maxWidth: 672 + 30 + 294,
    margin: "auto",
    marginTop: 32,
    marginBottom: 255,
    padding: "0 20px",
    boxSizing: "border-box",
  },
  ItemBoxTitle: {
    display: "flex",
    alignItems: "center",
    height: 70,
    fontFamily: "Roboto Condensed",
    color: "#251f1b",
    fontSize: 18,
    lineHeight: 1.39,
    letterSpacing: 1,
    fontWeight: "bold",
    marginLeft: 30,
  },
  emptyItemBox: (isItem) => ({
    width: "100%",
    maxWidth: 672,
    height: isItem ? 483 : "auto",
    backgroundColor: "#fff",
    border: "1px solid rgba(21, 41, 53, 0.1)",
    float: "left",
    boxSizing: "border-box",
    MozBoxSizing: "border-box",
    WebkitBoxSizing: "border-box",
  }),
  itemBoxNotice: {
    fontFamily: "Roboto Condensed",
    fontSize: 16,
    fontWeight: "600",
    color: "#251f1b",
    marginTop: 115,
    textAlign: "center",
  },
  summaryBox: (isCoupon) => ({
    width: "100%",
    maxWidth: 294,
    height: isCoupon ? 643 : 606,
    backgroundColor: "#fff",
    border: "1px solid rgba(21, 41, 53, 0.1)",
    marginLeft: 30,
    boxSizing: "border-box",
    MozBoxSizing: "border-box",
    WebkitBoxSizing: "border-box",
    float: "right",
    flexShrink: 0,
  }),
  summaryTitle: {
    fontFamily: "Roboto Condensed",
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.39,
    letterSpacing: 1,
    color: "#251f1b",
    marginTop: 24,
    marginLeft: 24,
  },
  costBox: (marginTop) => ({
    width: 246,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "auto",
    marginTop,
  }),
  totalText: {
    fontFamily: "Roboto Condensed",
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.39,
    letterSpacing: 1,
    color: "#251f1b",
  },
  noticeBox: {
    margin: "auto",
    marginTop: 16,
    width: 246,
    height: 52,
    borderRadius: 2,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  helpImg: {
    width: 14,
    height: 14,
    float: "left",
    marginLeft: 13,
    marginTop: 9,
  },
  noticeText: {
    width: 200,
    fontSize: 12,
    lineHeight: 1.5,
    letterSpacing: 0.3,
    color: "#251f1b",
    marginLeft: 9,
    float: "left",
    marginTop: 8,
    fontFamily: "Roboto Condensed",
  },
  underline: (marginTop) => ({
    margin: "auto",
    marginTop,
    width: 246,
    height: 1,
    backgroundColor: "rgba(21, 41, 53, 0.1)",
  }),
  footerNotice: {
    margin: "auto",
    width: 246,
    fontFamily: "Roboto Condensed",
    fontSize: 12,
    lineHeight: 1.83,
    color: "#251f1b",
    textAlign: "left",
    marginTop: 16,
  },
  footerNoticeJp: {
    margin: "auto",
    width: 246,
    fontFamily: "Roboto Condensed",
    fontSize: 12,
    lineHeight: 1.83,
    color: "#251f1b",
    textAlign: "left",
  },
  bluePointText: {
    fontFamily: "Roboto Condensed",
    fontSize: 12,
    lineHeight: 1.83,
    color: "#007dff",
    textAlign: "left",
    cursor: "pointer",
  },
  normalText: {
    fontFamily: "Roboto Condensed",
    fontSize: 12,
    lineHeight: 1.83,
    color: "#251f1b",
    textAlign: "left",
  },
  footerSubNoticeJp: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: 246,
    marginTop: 16,
  },
  footerSubNotice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: 246,
  },
  checkoutBtnBox: {
    width: 246,
    height: 40,
    backgroundColor: "#251f1b",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    marginTop: 20,
    position: "relative",
  },
  applyCouponBtn: {
    width: 198,
    height: 40,
    border: "solid 1px #251f1b",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#251f1b",
  },
  goShoppingBtn: {
    width: 240,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000",
    position: "relative",
    margin: "auto",
    marginTop: 35,
  },
  goShoppingTitle: {
    fontSize: 14,
    fontWeight: "600",
    letterSpacing: 0.2,
    color: "#fff",
  },
  goShoppingArrow: {
    width: 6,
    height: 8,
    position: "absolute",
    right: 10,
    zIndex: 2,
    top: 15,
  },
  couponInputBox: {
    marginTop: 20,
    marginLeft: 24,
    width: 246,
    height: 40,
    position: "relative",
  },
  couponCheckImg: {
    position: "absolute",
    top: "50%",
    right: 10,
    transform: "translateY(-50%)",
  },
  couponInputStyle: (borderColor) => ({
    width: 246,
    height: 40,
    backgroundColor: "#f7f7f7",
    border: `solid 1px ${borderColor}`,
    boxSizing: "border-box",
    WebkitBoxSizing: "border-box",
    MozBoxSizing: "border-box",
    padding: 10,
    color: "#251f1b",
    fontSize: 16,
    lineHeight: 1.5,
    outline: "none",
  }),
  applyBox: {
    width: 246,
    height: 40,
    margin: "auto",
    marginTop: 8,
    display: "flex",
    justifyContent: "space-between",
  },
  closeBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 40,
    border: "solid 1px #251f1b",
  },
  closeImg: {
    width: 16,
    height: 16,
  },
  couponNoticeTextBox: {
    margin: "auto",
    width: 246,
    marginTop: 8,
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: 11,
    lineHeight: 1.45,
  },
  cartTotalText: {
    fontFamily: "Roboto Condensed",
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: 1,
    color: "#251f1b",
  },
  checkoutTitle: {
    fontSize: 14,
    lineHeight: 1.36,
    letterSpacing: 0.5,
    color: "#fff",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
    lineHeight: 1.2,
    color: "#142935",
    fontFamily: "Roboto Condensed",
    marginTop: 20,
    marginLeft: 40,
  },
  noticeModalImg: {
    position: "absolute",
    top: 20,
    right: 40,
    cursor: "pointer",
  },
  policeBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 24,
  },
  policeBottomBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingLeft: 24,
    marginTop: 15,
    width: 246,
  },
  normalBottomText: {
    width: 224,
    fontFamily: "Metropolis",
    fontSize: 12,
    lineHeight: 1.67,
    letterSpacing: -0.3,
    color: "#251f1b",
  },
};

Cart.propTypes = {
  history: PropTypes.object,
  i18n: PropTypes.object,
  actions: PropTypes.object,
  // step: PropTypes.number,
  t: PropTypes.func,
};

Cart.defaultProps = {
  history: {},
  i18n: {},
  actions: null,
  // step: 2,
  t: () => {},
};

const defaultMapContextToProps = (value) => ({
  step: value.step,
  actions: value.actions,
});

export default Consumer(defaultMapContextToProps)(
  withRouter(withTranslation("translations")(Cart))
);
